import './couponMaster.scss';
import React, {useContext, useMemo, useRef, useState} from 'react';
import {Tag} from "antd";
import dayjs from "dayjs";
import {Sorter} from "../../../shared/components/Sorter";
import CouponEditModal from "../CouponEditModal";
import TablePage from "../../../pages/tablePage/TablePage";
import {getItemString} from "../../../shared/utils/basic";
import {AuthContext} from "../../../shared/contexts/authContext";
import {ENV, onOffValue} from "../../../shared/utils/enum";
import {useItemKrTextData} from "../../probability/useItemData";
import IsLoading from "../../../shared/components/IsLoading";
import ErrorPage from "../../../shared/components/ErrorPage";
import SanrioCouponStats from "./SanrioCouponStats";

const CouponMaster = () => {
    const { currentUser } = useContext(AuthContext);

    const [rowData, setRowData] = useState({});
    const refreshRef = useRef(null);

    const { data: krItemTextData, isLoading, error } = useItemKrTextData();

    const columns = useMemo(() => ([
        {
            title: '쿠폰 이름',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: '타입',
            dataIndex: 'type',
            render: (_, { type }) => (
                <Tag color={type ? 'green' : 'blue'}>
                    {type ? '개별' : '공용'}
                </Tag>
            ),
            filters: [
                {
                    text: '공용',
                    value: 0,
                },
                {
                    text: '개별',
                    value: 1,
                },
            ],
            onFilter: (value, record) => record.type === value,
        },
        {
            title: 'On/Off',
            dataIndex: 'onOff',
            render: (_, { onOff }) => (
                <Tag color={onOffValue[onOff].color}>
                    {onOffValue[onOff].text}
                </Tag>
            ),
            filters: [
                {
                    text: 'On',
                    value: 1,
                },
                {
                    text: 'Off',
                    value: 0,
                },
            ],
            onFilter: (value, record) => record.onOff === value,
        },
        {
            title: '보상 아이템',
            dataIndex: 'items',
            render: (items) => getItemString(krItemTextData[currentUser.target] ,items)
        },
        {
            title: 'Start',
            dataIndex: 'begin',
            render: (begin) => dayjs.unix(begin).format('YYYY-MM-DD HH:mm:ss'),
        },
        {
            title: 'End',
            dataIndex: 'end',
            render: (end) => dayjs.unix(end).format('YYYY-MM-DD HH:mm:ss'),
            sorter: (a, b) =>  Sorter.DATE(a.end, b.end),
        },
        {
            title: '우편 유효기간',
            dataIndex: 'validPeriod',
        }
    ]), [currentUser.target, krItemTextData]);

    if (isLoading) return <IsLoading />;
    if (error) return <ErrorPage error={error} />;

    const props = {
        columns,
        rowData,
        setRowData,
        modal: CouponEditModal,
        refreshRef,
        url: 'coupon/coupon_master',
        buttonText: '신규 쿠폰 추가',
        extraButtons: currentUser.target === ENV.PRODUCTION && <SanrioCouponStats/>,
    }

    return (
        <TablePage {...props}/>
    );
};

export default CouponMaster;